var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstoreicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2513 24.9569C16.8359 26.3289 15.2905 26.1123 13.8029 25.4623C12.2287 24.798 10.7844 24.7691 9.12352 25.4623C7.04378 26.3578 5.94614 26.0978 4.70407 24.9569C-2.34392 17.6922 -1.30406 6.62916 6.69716 6.22477C8.64691 6.32587 10.0045 7.29352 11.1455 7.38018C12.8497 7.03356 14.4817 6.03702 16.3015 6.167C18.4823 6.34031 20.1288 7.20687 21.212 8.76667C16.7059 11.4674 17.7746 17.4034 21.9052 19.0643C21.082 21.2307 20.0133 23.3826 18.2368 24.9713L18.2513 24.9569ZM11.0011 6.13811C10.7844 2.91741 13.3985 0.259967 16.4026 0C16.8214 3.7262 13.023 6.49918 11.0011 6.13811Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreicon);
export default __webpack_public_path__ + "static/media/appstoreicon.ffda2844e2a00cfbe5badc468d42aa76.svg";
export { ForwardRef as ReactComponent };